import { MutableRefObject, useEffect, useState } from 'react';

export function useIsInViewport(
  ref: MutableRefObject<HTMLElement | null>,
  options?: IntersectionObserverInit,
) {
  const [isInViewport, setIsInViewport] = useState<boolean | null>(null);
  const [observer, setObserver] = useState<IntersectionObserver | null>(null);

  useEffect(() => {
    if (ref.current && typeof IntersectionObserver !== 'undefined') {
      const intersectionObserver = new IntersectionObserver(
        ([entry]: IntersectionObserverEntry[]) => {
          if (entry) {
            setIsInViewport(entry.isIntersecting);
          }
        },
        options,
      );
      intersectionObserver.observe(ref.current);

      // Store observer in state so we can clean it up later
      if (!observer) {
        setObserver(intersectionObserver);
      }
    }

    return function cleanup() {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [ref, observer, options, setIsInViewport]);

  return isInViewport;
}
